var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-footer"},[_vm._v(" Copyright © Alfath Belajar ")])}
var staticRenderFns = []

export { render, staticRenderFns }